'use client';
import type { EnvironmentOperation } from '../../src/shared/wireContract';

const OPERATION_STATUSES = new Set(['pending', 'running', 'succeeded', 'failed']);

/** Validate durable operation rows at HTTP and pushed-event boundaries before sharing them with the dock. */
export function isEnvironmentOperation(body: unknown): body is EnvironmentOperation {
  if (!body || typeof body !== 'object') return false;
  const { id, status, action, projectId, accountUserId, generation, initiator, updatedAt, acknowledgedAt, steps, stepIndex, stepTotal, stepLabel, percent, error, errorCode } = body as Record<string, unknown>;
  if (typeof id !== 'string' || !id) return false;
  if (typeof status !== 'string' || !OPERATION_STATUSES.has(status)) return false;
  const kind = (action as Record<string, unknown> | undefined)?.kind;
  return typeof kind === 'string' && ['start', 'stop', 'restart', 'recreate', 'delete', 'snapshot', 'restore', 'deleteSnapshot', 'limits', 'network', 'rename'].includes(kind)
    && Number.isSafeInteger(projectId) && Number.isSafeInteger(generation)
    && (Number.isSafeInteger(accountUserId) || accountUserId === null && initiator === 'system')
    && ['ui', 'agent', 'system'].includes(String(initiator)) && typeof updatedAt === 'string'
    && (acknowledgedAt === null || typeof acknowledgedAt === 'string')
    && Array.isArray(steps) && steps.every(step => typeof step === 'string')
    && Number.isSafeInteger(stepIndex) && Number.isSafeInteger(stepTotal) && (stepLabel === null || typeof stepLabel === 'string')
    && (percent === null || typeof percent === 'number' && Number.isFinite(percent) && percent >= 0 && percent <= 100)
    && (error === null || typeof error === 'string')
    && (errorCode === undefined || typeof errorCode === 'string');
}
